import { ParsedUrlQuery } from "querystring";

export function getSizeQuery(query: ParsedUrlQuery): string | undefined {
  const { size } = query;
  if (!size) return undefined;
  return Array.isArray(size) ? size[0] : size;
}
